import styled from 'styled-components';
import BannerNewUser from './BannerNewUser';
import { colorSchema } from 'utils/style';

export default styled(BannerNewUser)`
  .banner-new-user {
    display: flex;
    flex-direction: column;
    justify-content: center;

    &__image {
      align-self: center;
      margin-bottom: 2.4rem;
      width: 225px;
    }

    &__title {
      color: ${colorSchema('grey900')};
      font-size: 2.4rem;
      font-weight: bold;
      margin-bottom: 0.8rem;
    }

    &__body {
      color: ${colorSchema('grey700')};
      font-size: 1.8rem;
      line-height: 1.28;
      margin: 1.6rem 0;
    }
  }
`;
